module.exports = __webpack_public_path__ + "media/images/emblems/Silvaplana_wappen-e7b804a6c716d85a9c33114323739f2e.svg";